import { lazy } from 'react';
import type { ReactNode } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import { RequireAuth } from '@/components/auth/RequireAuth';
import { HomePage } from '@/pages/HomePage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { LoginPage } from '@/pages/LoginPage';
import { RegisterPage } from '@/pages/RegisterPage';

// Приватные страницы лениво — они под Layout, который уже даёт <Suspense>.
// Login/Register/Home — eager: первый paint не должен моргать spinner'ом.
const CardioPage = lazy(() =>
  import('@/pages/CardioPage').then((m) => ({ default: m.CardioPage })),
);
const BodyPage = lazy(() => import('@/pages/BodyPage').then((m) => ({ default: m.BodyPage })));
const CalendarPage = lazy(() =>
  import('@/pages/CalendarPage').then((m) => ({ default: m.CalendarPage })),
);
const StrengthPage = lazy(() =>
  import('@/pages/StrengthPage').then((m) => ({ default: m.StrengthPage })),
);
const DietPage = lazy(() => import('@/pages/DietPage').then((m) => ({ default: m.DietPage })));
const MedicalPage = lazy(() =>
  import('@/pages/MedicalPage').then((m) => ({ default: m.MedicalPage })),
);
const FeedPage = lazy(() => import('@/pages/FeedPage').then((m) => ({ default: m.FeedPage })));
const HealthPage = lazy(() =>
  import('@/pages/HealthPage').then((m) => ({ default: m.HealthPage })),
);

const guarded = (element: ReactNode) => <RequireAuth>{element}</RequireAuth>;

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'cardio', element: guarded(<CardioPage />) },
      { path: 'strength', element: guarded(<StrengthPage />) },
      { path: 'body', element: guarded(<BodyPage />) },
      { path: 'health', element: guarded(<HealthPage />) },
      { path: 'diet', element: guarded(<DietPage />) },
      { path: 'feed', element: guarded(<FeedPage />) },
      { path: 'medical', element: guarded(<MedicalPage />) },
      { path: 'calendar', element: guarded(<CalendarPage />) },
    ],
  },
  { path: '/login', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },
  { path: '*', element: <NotFoundPage /> },
];
